export default __webpack_public_path__ + "static/media/crew-09-bit.945c0e2c.svg";